import Model from '../model';
import ConversationModel from '../Conversation/model'
import CompanySelector from './selector'
import UserModel from '/app/src/model/User/model';
import {NetworkSelector} from '/app/src/model/selectors';
import request from 'superagent';
import * as actions from './actions';
import { toast } from 'react-toastify';

class Company extends Model {
    update(updates) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            request
            .post(`${url}/v1/company/update`)
            .accept('application/json')
            .send({updates: updates})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                switch(res.statusCode) {
                    case 200:
                        dispatch(actions.setCompanyInfo(res.body.company))
                        break;
                    default:
                        return;
                }
            });
        }
    }

    cancelNext(pwd) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            request
            .post(`${url}/v2/api/payment/cancel/next`)
            .accept('application/json')
            .send({password: pwd})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                switch(res.statusCode) {
                    case 200:
                        dispatch(actions.setPaymentStatus(res.body.payment_status))
                        toast.success('Tråkigt att du lämnar oss. Om du har feedback du vill lämna så kan du plinga oss på chatten.')
                        break;
                    case 401:
                        toast.error('Lösenordet stämmer inte.')
                        break
                    default:
                        toast.error('Någonting gick fel. Försök igen.')
                        return;
                }
            });
        }
    }

    delete(pwd) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            request
            .post(`${url}/v1/company/cancel`)
            .accept('application/json')
            .send({password: pwd})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                console.log(err, res)
                switch(res.statusCode) {
                    case 200:
                        dispatch(UserModel.logout())
                        toast.success('Tråkigt att du lämnar oss. Om du har feedback du vill lämna så kan du plinga oss på chatten.')
                        break;
                    default:
                        toast.error('Lösenordet stämmer inte.')
                        return;
                }
            });
        }
    }




    invoiceRead() {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.invoiceReadRequest())
            request
            .get(`${url}/v1/payment/invoices`)
            .accept('application/json')
            .send({})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                switch(res.statusCode) {
                    case 200:
                        const invoices = res.body.invoices;
                        dispatch(actions.invoiceReadSuccess(invoices));
                        break;
                    default:
                        dispatch(actions.invoiceReadFailure(err, res));
                        break;
                }
            });
            return actions.invoiceReadRequest()
        }
    }

    //DEPRECATED: Use billingInfoRead that adhers to the new paradigm
    billingRead() {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.billingReadRequest())
            request
            .get(`${url}/v1/payment/billing_info`)
            .accept('application/json')
            .send({})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                switch(res.statusCode) {
                    case 200:
                        const billingInformation = res.body.data;
                        dispatch(actions.billingReadSuccess(billingInformation));
                        break;
                    default:
                        dispatch(actions.billingReadFailure(err, res));
                        break;
                }
            });
        }
    }

    billingInfoRead() {
        const selector = (state) => ({
            network: NetworkSelector.get(state, 'billing info read'),
            selector: CompanySelector.getCompanyBillingInfo(state)
        })

        const dispatcher = (dispatch) => {
            const url = this.url()
            const token = this.token()
            dispatch(actions.billingReadRequest())
            request
            .get(`${url}/v1/payment/billing_info`)
            .accept('application/json')
            .send({})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                switch(res.statusCode) {
                    case 200:
                        const billingInformation = res.body.data;
                        dispatch(actions.billingReadSuccess(billingInformation));
                        break;
                    case 404:
                    default:
                        dispatch(actions.billingReadFailure(err, res));
                        break;
                }
            });
        }
        return {selector: selector, dispatcher: dispatcher}
    }

    pricePlanCompleteUpgrade(invoice_period, subscription_mode, plan) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            return request
            .post(`${url}/v2/api/payment/plan/update`)
            .accept('application/json')
            .send({
                invoice_period,
                subscription_mode,
                'package': plan //NOTE: package is a reserved word
            })
            .set('Authorization', 'Bearer ' + token)
            .then( (res) => {
            })
            .catch( (err) => {
                throw(err)
            });
        }
    }

    pricePlanResume(invoice_period, subscription_mode, plan) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            return request
            .post(`${url}/v2/api/payment/resume`)
            .accept('application/json')
            .send({
                invoice_period,
                subscription_mode,
                'package': plan //NOTE: package is a reserved word
            })
            .set('Authorization', 'Bearer ' + token)
            .then( (res) => {
            })
            .catch( (err) => {
                throw(err)
            });
        }
    }

    pricePlanChangeSub(invoice_period) {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            request
            .post(`${url}/v1/payment/billing_info`)
            .accept('application/json')
            .send({ invoice_period })
            .set('Authorization', 'Bearer ' + token)
            .then( (res) => {
            })
            .catch( (err) => {
                throw(err)
            });
        }
    }

    billingPut(isPrivate, companyName, address, email, city, orgNumber, postalCode, referenceName, referenceEmail){
        return (dispatch) => {
            const url = this.url()
            const token = this.token()

            dispatch(actions.billingReadRequest())

            request
            .put(`${url}/v1/payment/billing_info`)
            .accept('application/json')
            .send({
                address:address,
                city: city,
                postal_code: postalCode,
                name: companyName,
                email: email,
                is_private_person: isPrivate,
                ref_name: referenceName,
                ref_email: referenceEmail,
                org_nbr: orgNumber
            })
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    const billingInformation = {
                        private_person: isPrivate,
                        name: companyName,
                        address: address,
                        email: email,
                        city: city,
                        org_nbr: orgNumber,
                        postal_code: postalCode,
                        ref_email: referenceEmail,
                        ref_name: referenceName
                    }
                    dispatch(actions.billingReadSuccess(billingInformation));
                    toast.success('Betalningsinformation uppdaterades!')
                }else {
                    dispatch(actions.billingReadFailure(err, res));
                }
            });
        }
    }
    billingPost(isPrivate, companyName, address, email, city, orgNumber, postalCode, referenceName, referenceEmail){
        return (dispatch) => {
            const url = this.url()
            const token = this.token()

            dispatch(actions.billingReadRequest())

            request
            .post(`${url}/v1/payment/billing_info`)
            .accept('application/json')
            .send({
                address:address,
                city: city,
                postal_code: postalCode,
                name: companyName,
                email: email,
                is_private_person: isPrivate,
                ref_name: referenceName,
                ref_email: referenceEmail,
                org_nbr: orgNumber
            })
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    const billingInformation = {
                            private_person: isPrivate,
                            name: companyName,
                            address: address,
                            email: email,
                            city: city,
                            org_nbr: orgNumber,
                            postal_code: postalCode,
                            ref_email: referenceEmail,
                            ref_name: referenceName
                    }
                    dispatch(actions.billingReadSuccess(billingInformation));
                }else {
                    dispatch(actions.billingReadFailure(err, res));
                }
            });
        }
    }
    put(info){
        return (dispatch) => {
            dispatch(actions.setCompanyInfo(info))
       }
    }

    readHistoryPage(page){
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            const offset = (page - 1) * 10;
            dispatch(actions.historyReadRequest(page))
            request
            .get(`${url}/v1/company/tickets/history`)
            .accept('application/json')
            .send({})
            .query(`offset=${offset}`)
                .set('Authorization', 'Bearer ' + token)
                .end((err, res) => {
                if (res.statusCode === 200){
                    const conversations= res.body.tickets
                    dispatch(ConversationModel.__setManyTicketPayload(conversations, 'resolved'));
                    dispatch(actions.historyReadSuccess(page, conversations.room, res.body.count))
                }else{
                    dispatch(actions.historyReadFailure())
                }
            });
        }
    }
    statsTicketCreatedRead(duration, tick){
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            request
            .post(`${url}/v1/company/stats/ticket/created`)
            .accept('application/json')
            .send({tick: tick, duration: duration})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    dispatch(actions.statsTicketCreatedPostSuccess(res.body.stats))
                }
            });
        }
    }
    statsTicketCreatedReadExact(unit, info){
        return (dispatch) => {

            let url = this.url();
            let token = this.token();
            request
            .post(`${url}/v1/company/stats/ticket/created/exact`)
            .accept('application/json')
            .send({'unit': unit, 'info': info})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    dispatch(actions.statsTicketCreatedPostSuccess(res.body.stats))
                }
            });
        }
    }
    statsTicketCreatedAdd(time, value){
        return (dispatch)=>{
            dispatch(actions.statsTicketCreatedAdd(time, value))
        }
    }

    statsTicketResponseTimeReadExact(unit, info){
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            request
            .post(`${url}/v1/company/stats/ticket/response/exact`)
            .accept('application/json')
            .send({'unit': unit, 'info': info})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    dispatch(actions.statsTicketResponseTimePostSuccess(res.body.stats))
                }
            });
        }
    }

    // statsRating(){
    //     console.log("statsRating")
    //     return (dispatch) => {
    //         let url = this.url();
    //         let token = this.token();
    //         request
    //         .post(`${url}/v1/company/stats/employees_rating`)
    //         .accept('application/json')
    //         .send({})
    //         .set('Authorization', 'Bearer ' + token)
    //         .end((err, res) => {
    //             if (res.statusCode === 200) {
    //                 dispatch(actions.statsRatingResponseSuccess(res.body.stats))
    //             }
    //         });
    //     }
    // }

    getLatestRatingsRequest() {
        const url = this.url()
        const token = this.token()
        return request
            .post(`${url}/v2/company/stats/employees_rating`)
            .accept('application/json')
            .send({})
            .set('Authorization', 'Bearer ' + token)
    }

    statsLive(){
        return (dispatch) => {
            let url = this.url();
            let token = this.token();
            request
            .post(`${url}/v1/company/stats/live`)
            .accept('application/json')
            .send({})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    dispatch(actions.statsLiveSuccess(res.body.stats))
                }
            });
        }
    }

    statsLiveUpdateNbr(key, value){
        return (dispatch) => {
            dispatch(actions.statsLiveUpdateNbr(key, value))
        }
    }
    statsResponseTimeAdd(createdTime, durationTime){
        return (dispatch)=>{
            dispatch(actions.statsResponseTimeAdd(createdTime, durationTime))
        }
    }



}

export default new Company();



// WEBPACK FOOTER //
// ./src/model/Company/model.js